import React, { FC } from 'react'

const Brands:FC = () => {
  return (
    <div className='title__container'>
        <div className="title__wrapper">
            <img src="/img/widgets/brands.png" alt=''/>
        </div>
    </div>
  )
}

export default Brands